import { requestClanSupplyProgressionSettingsInfo } from './clan_supply_progression_settings'
import { requestClanSupplyProgressionInfo } from './clan_supply_progression'

export function requestClanSupplyProgressionMainInfo() {
    return async (dispatch, getState) => {
        await dispatch(requestClanSupplyProgressionSettingsInfo())

        const state = getState()

        if (state.clanSupplyProgressionSettings.enabled) {
            await dispatch(requestClanSupplyProgressionInfo())
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/clan_supply_progression_main.js